import React, { useEffect, useRef, useState } from 'react';
import './WhoWeAreSection.css';
import whoWe from "../../assests/salestology-img03.webp"

const WhoWeAreSection = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    // Optionally disconnect observer after first trigger
                    observer.disconnect();
                }
            },
            {
                threshold: 0.2, // Trigger when 20% of the component is visible
                rootMargin: '0px 0px -50px 0px' // Start animation slightly before fully visible
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <section ref={sectionRef} id="who-we-are-section" className="who-we-are-section">
                <div className="who-we-are-container">
                    <div className="content-wrapper">
                        <div className={`text-content ${isVisible ? 'animate' : ''}`}>
                            <div className="section-badge">WHO WE ARE</div>
                            <h2 className="main-title">
                                Who We Are And How We Operate
                            </h2>
                            <p className="description">
                                SalesTology was founded in 2024 by Zuheir Shahwan. Mr. Shahwan is a global commercial executive with more than two decades experience in sales, sales operations, and distribution channel management. During his corporate career as a senior leader, he developed and led global teams at major Fortune 500 companies in manufacturing and Life Sciences (Cummins Inc, and Eli Lilly). He is well versed in the challenges sales organizations face today, especially when it comes to adopting new processes or technologies. Mr. Shahwan’s experience and proven track record in leading change and driving sustainable profitable growth makes him an ideal partner for any organization that is serious about modernizing their sales capability. Zuheir is passionate about solving complex business challenges and thrives on building world-class capabilities.
                            </p>

                        </div>

                        <div className={`image-wrapper ${isVisible ? 'animate' : ''}`}>
                            <img
                                src={whoWe}
                                alt="Business team meeting"
                                className="main-image"
                            />
                        </div>
                    </div>

                    <div className={`additional-content ${isVisible ? 'animate' : ''}`}>
                        <p className="additional-text">
                            At SalesTology we believe that the key to achieving successful change rests within the <strong>human factor</strong>. Senior leadership buy-in and sponsorship supported by a clear <strong>sense of purpose</strong>, an elegant <strong>implementation plan</strong>, and well-defined <strong>Key Performance Indicators (KPIs)</strong> are critical success factors. Our <strong>proprietary sales capability improvement process</strong> provides leaders with a clear view of the various areas of strength and opportunity along with a clear journey map for success. This process represents a culmination of extensive <strong>real-world experience</strong> in developing world class commercial organizations <strong>supported by scientific</strong> methodologies like Lean Six Sigma and Organizational Effectiveness frameworks.
                        </p>
                        <p className="additional-text">
                            SalesTology also provides <strong>Business Intelligence</strong> and Analytics solutions. A well-trained team with deep expertise in reporting, analytics and A.I. is able to produce <strong>clients-pecific B.I. solutions</strong> to drive strong adoption and enhanced sales results.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhoWeAreSection;